import React from "react";

// Cimponents
import { PlusOutlined } from "@ant-design/icons";
import { Flex } from "antd";

const AddItemButton = ({
  text,
  onClick,
  fontSize = "16px",
  fontWeight = "500",
  marginTop= "16px",
  width= "36px",
  height= "36px",
}) => {
  return (
    <Flex
      onClick={onClick}
      align="center"
      gap="middle"
      style={{
        cursor: "pointer",
        marginTop: marginTop,
        fontSize: fontSize,
        fontWeight: fontWeight,
        width: "max-content",
      }}
    >
      <span
        style={{
          background: "#F3F3F3",
          width: width,
          height: height,
          borderRadius: "50px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <PlusOutlined
          style={{
            color: "black",
          }}
        />
      </span>
      {text}
    </Flex>
  );
};

export default AddItemButton;
